// Read the API host from the build environment (.env-local for dev builds,
// .env-production for production builds) like src/config/axios.js does.
// A hard-coded host here once pointed every legacy screen at the dev API in
// whichever build it ended up in.
export const API_URL = process.env.REACT_APP_API_URL;
export const LOGIN_URL = process.env.REACT_APP_LOGIN_API;
